import { render, staticRenderFns } from "./OnGoing.vue?vue&type=template&id=7aee1275"
import script from "./OnGoing.vue?vue&type=script&lang=js"
export * from "./OnGoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports